import { RegulatoryOrderingKey } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import {
  ORDERING_TABLE,
  Ordering,
  TABLE_HEADER_LIST,
  TableHeaderList,
} from "../../../constants/RegulatoryTable.constants";

interface UseHandleRegulatoryTableOrderingReturn {
  tableHeaderList: TableHeaderList[];
  handleOrdering: (
    orderingTitle: RegulatoryOrderingKey,
    ordering: Ordering,
  ) => void;
  getOrderingIcon: (ordering: Ordering) => string;
  checkIsOrdering: (ordering: Ordering) => boolean;
}

export const useHandleRegulatoryTableOrdering =
  (): UseHandleRegulatoryTableOrderingReturn => {
    const [regulatoryListFilter, setRegulatoryListFilter] =
      useRegulatoryListFilterState();
    const { order } = regulatoryListFilter;

    const tableHeaderList: TableHeaderList[] = TABLE_HEADER_LIST.map(
      (tableHeader) => {
        const orderingValue = order[tableHeader.orderingTitle] || "none";
        return {
          ...tableHeader,
          ordering: orderingValue,
        };
      },
    );

    const handleOrdering = (
      orderingTitle: RegulatoryOrderingKey,
      ordering: Ordering,
    ) => {
      const updatedOrdering = ORDERING_TABLE[ordering];
      let updatedOrderObject = { ...order };

      if (orderingTitle in order) {
        delete updatedOrderObject[orderingTitle];
      }

      updatedOrderObject = {
        ...updatedOrderObject,
        [orderingTitle]: updatedOrdering,
      };

      if (updatedOrdering === "none") {
        delete updatedOrderObject[orderingTitle];
      }
      setRegulatoryListFilter({
        ...regulatoryListFilter,
        order: updatedOrderObject,
      });
    };

    const getOrderingIcon = (ordering: Ordering) => {
      if (ordering === "asc") return "▲";
      if (ordering === "desc") return "▼";
      return "";
    };

    const checkIsOrdering = (ordering: Ordering) => {
      if (ordering === "none") return false;
      return true;
    };

    return {
      tableHeaderList,
      handleOrdering,
      getOrderingIcon,
      checkIsOrdering,
    };
  };
